import {
  Guest,
  CreateGuestDto,
  GuestFilterQuery,
  GuestFilterResponse,
  UpdateGuestDto,
} from "@/types/guest";
import { BaseService } from "./BaseService";
import { IGuestService } from "./interfaces/IGuestService";

class GuestService extends BaseService implements IGuestService {
  private basePath = "/guests";

  constructor() {
    super();
  }

  async getGuestById(id: string): Promise<Guest> {
    return this.get<Guest>(`${this.basePath}/${id}`);
  }

  async getGuestFilterOptions(
    query: GuestFilterQuery,
  ): Promise<GuestFilterResponse> {
    return this.get<GuestFilterResponse>(this.basePath, query);
  }

  async createGuest(guestData: CreateGuestDto): Promise<Guest> {
    return this.post<Guest>(this.basePath, guestData);
  }

  async updateGuest(
    id: string,
    guestData: UpdateGuestDto,
  ): Promise<{ guest: Guest }> {
    return this.patch<{ guest: Guest }>(`${this.basePath}/${id}`, guestData);
  }
}

export const guestService = new GuestService();
